import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { login } from "./userApi";

const initialState = {
  user: [],
  userById: [],
  userList: [],
  ambientes: [],
  ambienteActive: {},
};

export const loginAsync = createAsyncThunk(
  "user/login",
  async (data, { dispatch }) => {
    const response = await login(data);
    dispatch(setUser(response));
    return response;
  }
);


export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logOut: (state) => {
      localStorage.setItem("dbhloggedead", false);
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setList: (state, action) => {
      state.userList = action.payload;
    },
  },
});

export const { logOut, setUser, setList } = userSlice.actions;

export const selectUser = (state) => state.user.user[0];
export const List = (state) => state.user.userList;
export const User = (state) => state.user.userById[0];

export default userSlice.reducer;

